module.exports = __webpack_public_path__ + "static/media/5DPO22.1ee0059b.jpg";